import React, { useEffect, useRef, useState } from "react";
import {
  FaReact, FaNodeJs, FaPython, FaCss3Alt, FaGitAlt, FaDocker, FaAws, FaFigma,
} from "react-icons/fa";
import {
  SiJavascript, SiTypescript, SiMongodb, SiPostgresql, SiPhp, SiLaravel,
} from "react-icons/si";
import { personalInfo, skills, funFacts } from "../../data/portfolioData";
import "./About.css";

const iconMap = {
  FaReact: <FaReact />,
  SiJavascript: <SiJavascript />,
  SiTypescript: <SiTypescript />,
  FaNodeJs: <FaNodeJs />,
  FaPython: <FaPython />,
  FaCss3Alt: <FaCss3Alt />,
  FaGitAlt: <FaGitAlt />,
  SiMongodb: <SiMongodb />,
  SiPostgresql: <SiPostgresql />,
  SiPhp: <SiPhp />,
  SiLaravel: <SiLaravel />,
  FaDocker: <FaDocker />,
  FaAws: <FaAws />,
  FaFigma: <FaFigma />,
};

const About = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="about" id="about" ref={sectionRef}>
      <div className="about__container">
        <h2 className="section-title">About Me</h2>
        <p className="section-subtitle">Get to know me better</p>

        <div className="about__grid">
          {/* Bio */}
          <div className={`about__bio ${visible ? "animate-slide-right" : ""}`}>
            <p className="about__text">{personalInfo.bio}</p>

            <div className="about__fun-facts">
              <h3>Fun Facts</h3>
              <ul>
                {funFacts.map((fact, idx) => (
                  <li key={idx}>{fact}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Skills */}
          <div className={`about__skills ${visible ? "animate-slide-left" : ""}`}>
            <h3>My Skills</h3>
            <div className="skills__categories">
              {skills.map((group, gIdx) => (
                <div
                  className="skills__category-card"
                  key={gIdx}
                  style={{ animationDelay: `${gIdx * 0.12}s` }}
                >
                  <h4 className="skills__category-title">{group.category}</h4>
                  <div className="skills__tags">
                    {group.items.map((skill, idx) => (
                      <span className="skill-tag" key={idx}>
                        <span className="skill-tag__icon">{iconMap[skill.icon]}</span>
                        {skill.name}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
